import { Cadenas } from 'assets/icons';
import UseContext from 'hooks/useContext';
import TemplateDetail from './templateDetail';
import SummaryField from './summaryField';
import { getTemplateTitle } from './missionTemplateFormat';
import { useRiskyPositions } from './missionTemplateRiskyPositions';

const MOTIF_TITLES = {
  1: "Accroissement temporaire d'activité",
  2: 'En attente de recrutement',
  3: "Remplacement d'un salarié absent",
  4: "Contrat temporaire d'usage",
  5: 'Emploi à caractère saisonnier',
};

const dayMonthYear = (value) => {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return '';
  const [day, month, year] = new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'Europe/Paris',
  })
    .format(date)
    .split(' ');
  return `${day} ${month.charAt(0).toUpperCase()}${month.slice(1)} ${year}`;
};

/** What the admin filled on top, what the job description holds below. */
const TemplateMissionConfirmation = ({ goToStep }) => {
  const { dataCreateMission } = UseContext();
  const riskyPositions = useRiskyPositions();
  const template = dataCreateMission.missionTemplate;
  const motif = dataCreateMission.motif || {};
  const motifDetail = [
    [motif.prenom, motif.name].filter(Boolean).join(' '),
    motif.poste,
    motif.date ? dayMonthYear(motif.date) : '',
    motif.message,
  ]
    .filter((part) => typeof part === 'string' && part.trim() !== '')
    .join(' — ');
  const period =
    dataCreateMission.dateStart && dataCreateMission.dateEnd
      ? `${dayMonthYear(dataCreateMission.dateStart)} > ${dayMonthYear(
          dataCreateMission.dateEnd
        )}`
      : '';
  const invitations = [
    ...(dataCreateMission.user_assigned?.name
      ? [`${dataCreateMission.user_assigned.name} (assigné)`]
      : []),
    ...(dataCreateMission.users_invite || []).map(({ name }) => name),
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col">
        <span className="ft-xl font-medium text-gray-900">Confirmation</span>
        <span className="ft-sm text-gray-500">
          Vérifiez les informations de la mission avant de la créer. Les
          sections issues de la fiche de poste ne sont pas modifiables ici.
        </span>
      </div>

      <div className="flex flex-col">
        <SummaryField
          label="Motif"
          value={MOTIF_TITLES[motif.type]}
          detail={motifDetail}
          editLabel="Modifier le motif"
          onEdit={() => goToStep('motif')}
        />
        <SummaryField
          label="Période de la mission"
          value={period}
          editLabel="Modifier la période"
          onEdit={() => goToStep('period')}
        />
        <SummaryField
          label="Référence"
          value={dataCreateMission.reference}
          editLabel="Modifier la référence"
          onEdit={() => goToStep('details')}
        />
        <SummaryField
          label="Invitations"
          value={invitations}
          editLabel="Modifier les invitations"
          onEdit={() => goToStep('invitation')}
        />
      </div>

      <div className="rounded-lg bg-gray-100 sh-sm">
        <div className="flex items-center gap-2 px-4 py-3 ft-sm text-gray-700">
          <span aria-hidden="true">
            <Cadenas wh={16} color="#6B7280" />
          </span>
          <span>Fiche de poste : {getTemplateTitle(template)}</span>
        </div>
        <div className="px-1.5 pb-1.5">
          <div className="bg-white rounded-md px-4">
            <TemplateDetail
              template={template}
              riskyPositions={riskyPositions}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateMissionConfirmation;
